import { Directive, ElementRef, Injector} from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  selector: 'impressum'
})
export class ImpressumDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('impressum', elementRef, injector);
  }
}



// WEBPACK FOOTER //
// ./src/components/app/impressum/impressum.directive.ts